import { Component, ViewChild, Input, ElementRef } from "@angular/core";
import { joinmeetingService } from "../../Communication/joinmeeting/joinmeeting/joinmeeting.service";
import { GenEnum } from "../../../shared/general.enum";
import {
  StartMeeting,
  JoinMeeting,
  Participant,
  StaffJoinMeeting,
} from "./interface";
import { AppConstants } from "../../../../app.constant";
import { NavModalComponent } from "../../../../core/component/NavModal.Component";
import { IXSModalComponent } from "../../../../components/ixsmodal/ixsmodal.component";
import { Router } from "@angular/router";
import { Observable } from "rxjs/Observable";
declare var JitsiMeetExternalAPI: any;
import * as moment from "moment";
import {
  CanvasWhiteboardComponent,
  CanvasWhiteboardOptions,
} from "ng2-canvas-whiteboard-compat";
@Component({
  moduleId: module.id,
  selector: "online-session",
  templateUrl: "online-session.component.html",
  styleUrls: ["online-session.component.scss"],
})
export class OnlineSessionComponent extends NavModalComponent<any> {
  @ViewChild("meetingmodal") meetingmodal: IXSModalComponent;
  @ViewChild("Meetinginstruction") Meetinginstruction: IXSModalComponent;

  domain: string = "meet.jit.si";
  options: any = {};
  api: any;
  AllActiveParticipants: any = [];
  guesttypeid: number = 0;
  ischeckmeeting: boolean = true;
  instructionlist: any = [];
  @Input()
  roomname: string = "";

  @Input()
  meetingid: Number;

  @Input()
  token: string = "";

  @Input()
  participantid: Number;

  @Input()
  typeid: Number = 1;

  @ViewChild("opensession") opensession: IXSModalComponent;
  @ViewChild("startMeetingbtn") startMeetingbtn: ElementRef;

  @ViewChild("mymodal") mymodal: ElementRef;

  check: boolean = false;
  particapentheight: string | number;
  checkmeeting: any;
  meetingtypeid: any;

  constructor(private joinmeetingService: joinmeetingService) {
    super(joinmeetingService);
  }

  async ngOnInit() {
    await this.gethostingURL();
  }

  async gethostingURL() {
    const url = await this.joinmeetingService.gethostingURL();
    if (url && url.IsSuccess && url.Data) {
      this.domain = url.Data.hostingurl;
    }
  }

  async initilizeForm() {
    this.title = "Join Meeting";
    this.myForm = this.fb.group({
      ltxt: ["", []],
    });
    this.meetingtypeid = Number(this.localStorage.get("calltype"));
  }

  currentmeeting: any;
  async startmeeting() {
    this.startLoading();

    this.currentmeeting = JSON.parse(this.localStorage.get("currentmeeting"));

    this.startLoading();
    await this.initilizeForm();
    this.meetingid = Number(this.localStorage.get("meetingid"));
    this.roomname = this.localStorage.get("roomname");
    this.participantid = Number(this.localStorage.get("participantid"));
    this.typeid = Number(this.localStorage.get("calltype"));

    if (!this.participantid || Number(this.participantid) === 0) {
      let loginUserInfo = JSON.parse(this.localStorage.get("LoginUserInfo"));
      if (loginUserInfo) {
        this.localStorage.set("participantid", loginUserInfo.Id);

        this.participantid = Number(this.localStorage.get("participantid"));
      }
    }
    if (this.typeid !== 2) {
      this.startLoading();
      let dto = await this.joinmeetingService.startmeeting(
        this.meetingid,
        this.participantid
      );
      if (dto && dto.IsSuccess) {
        this.stopLoading();
      } else {
        this.showErrors(dto.Errors);
        this.stopLoading();
      }
      this.stopLoading();
    } else {
      this.participantid = Number(this.localStorage.get("Studentid"));
      this.startLoading();
      let dto = await this.joinmeetingService.setParticpantStatus(
        this.participantid,
        this.meetingid,
        GenEnum.Participant_Status.Join,
        GenEnum.Guestype.Student
      );

      if (dto && dto.IsSuccess) {
        this.stopLoading();
      } else {
        this.showErrors(dto.Errors);
        this.stopLoading();
      }
      this.stopLoading();
    }

    await this.initializeMeeting(this.roomname);
    this.startMeetingbtn.nativeElement.disabled = true;
    this.stopLoading();
  }

  async endMeeting() {
    if (this.api) {
      this.api.dispose();
    }

    this.meetingid = Number(this.localStorage.get("meetingid"));

    this.startMeetingbtn.nativeElement.disabled = false;
    window.close();
  }

  async disposeMeeting() {
    await this.joinmeetingService.updateMeetingStatus(this.meetingid, GenEnum.Complaint_Status.Closed);
  }

  closeModal() {
    this.mymodal.nativeElement.click();
  }

  async initializeMeeting(roomname) {
    this.startLoading();

    let Toolbars =
      this.typeid === 2
        ? JoinMeeting
        : this.typeid == 3
          ? StaffJoinMeeting
          : StartMeeting;

    let userInfo = await this.joinmeetingService.getParticipantInfo(
      this.meetingid,
      this.participantid
    );
    let partciapntInfo = {
      email: "",
      code: "",
      image: "",
      firstname: "",
      contact: "",
    };
    if (userInfo && userInfo.Data) {
      partciapntInfo = {
        code: userInfo.Data.code,
        firstname: userInfo.Data.firstname,
        email: userInfo.Data.email,
        contact: userInfo.Data.contact,
        image:
          this.localStorage.get("OnlyUrl") +
          GenEnum.Image.imageUrl +
          userInfo.Data.url,
      };

      if (this.AllActiveParticipants) {
        this.AllActiveParticipants.push(partciapntInfo);
      }
    }
    this.particapentheight =
      this.typeid === 2 ? 300 : this.typeid === 3 ? 620 : "100%";

    this.options = {
      roomName: roomname,
      userInfo: {
        email: partciapntInfo.email,
        displayName: partciapntInfo.firstname,
      },

      configOverwrite: {
        disableRemoteMute: this.typeid == 2 || this.typeid == 3 ? true : false,
        remoteVideoMenu: {
          disableKick: this.typeid == 2 || this.typeid == 3 ? true : false,
        },
        startWithVideoMuted:
          this.typeid == 2 || this.typeid == 3 ? true : false,
      },

      interfaceConfigOverwrite: {
        TOOLBAR_BUTTONS: Toolbars,
        disableDeepLinking: true,
        SHOW_JITSI_WATERMARK: false,
        SHOW_WATERMARK_FOR_GUESTS: false,
        SHOW_BRAND_WATERMARK: false,
        BRAND_WATERMARK_LINK: "Edu-man",
        APP_NAME: "Edu-man",
        MOBILE_APP_PROMO: false,
        SHOW_CHROME_EXTENSION_BANNER: false,
      },

      parentNode: document.querySelector("#meet"),
    };

    this.api = new JitsiMeetExternalAPI(this.domain, this.options);

    if (userInfo && userInfo.Data) {
      this.api.executeCommand("subject", userInfo.Data.subject);
    }

    this.api.on("videoConferenceJoined", async (event) => {
      await this.videoConferenceJoined(event);
    });

    this.api.on("participantKickedOut", async (event) => { });

    this.api.on("videoConferenceLeft", async (event) => {
      await this.videoConferenceLeft(event);
    });

    this.api.on("participantJoined", async (event) => {
      await this.participantJoined(event);
    });

    this.api.on("participantLeft", async (event) => {
      await this.participantLeft(event);
    });
    this.api.on("readyToClose", async () => {
      await this.readyToClose(event);
    });
  }

  async readyToClose(event: any) {
    window.close();
    this.closeModal();
  }

  async videoConferenceJoined(object: Participant) {
    this.ParticipantsCollection(object, GenEnum.Participant_Status.Join);
  }

  async videoConferenceLeft(object: Participant) {
    this.ParticipantsCollection(object, GenEnum.Participant_Status.Left);
  }
  async participantLeft(object: Participant) {
    this.ParticipantsCollection(object, GenEnum.Participant_Status.Left);
  }
  async participantJoined(object: Participant) {
    this.ParticipantsCollection(object, GenEnum.Participant_Status.Join);
  }

  async PostStatus(participantid, statusid) {
    let result = await this.joinmeetingService.setParticpantStatus(
      participantid,
      this.meetingid,
      statusid,
      this.guesttypeid
    );
    if (result && result.Data) {
      return result.Data;
    }
  }

  ParticipantsCollection(object: Participant, typeid) {
    if (typeid === GenEnum.Participant_Status.Join) {
      this.AllActiveParticipants.push(object);
    } else {
      let obj = this.AllActiveParticipants.filter((o) => o.id === object.id)[0];
      const indxof = this.AllActiveParticipants.indexOf(obj);
      this.AllActiveParticipants.splice(indxof, 1);
    }
  }

  async particaptelist() {
    if (this.check === false) {
      this.check = true;
      var element = document.getElementById("Participants");
      element.classList.add("Participants");
      var element = document.getElementById("Participants");
      element.classList.remove("Participants-disable");
    } else if (this.check === true) {
      this.check = false;
      var element = document.getElementById("Participants");
      element.classList.remove("Participants");
      var element = document.getElementById("Participants");
      element.classList.add("Participants-disable");
    }
  }

  async getactiveParticipant() {
    if (this.joinmeetingService) {
      let participants = await this.joinmeetingService.getActiveParticipants(
        this.meetingid
      );

      if (participants && participants.Data) {
        participants.Data.forEach((element) => {
          element.image =
            this.localStorage.get("OnlyUrl") +
            GenEnum.Image.imageUrl +
            element.image;
        });

        this.AllActiveParticipants = participants.Data;
      }
    }
  }

  async checkmeetingtime() {
    this.checkmeeting = Observable.interval(10000).subscribe((val) => {
      if (this.ischeckmeeting === true) {
        if (this.currentmeeting) {
          var time = new Date();
          let endtime = new Date(this.currentmeeting.edtime);
          if (time >= endtime) {
            this.meetingmodal.customOpen("sm");
          }
        }
      } else {
        this.checkmeeting.unsubscribe();
      }
    });
  }
  async meetingcontinue() {
    this.ischeckmeeting = false;
    this.checkmeeting.unsubscribe();
    this.meetingmodal.close();
  }
  async meetingclose() {
    this.endMeeting();
    this.meetingmodal.close();
    this.closeModal();
    this.ischeckmeeting = false;
    $("div").hasClass("modal-backdrop fade in hidden");
  }
  muteEveryone() {
    if (this.api) {
      this.api.executeCommand("muteEveryone");
    }
  }
  async Meetinginstructionmodalopen() {
    this.instructionlist = JSON.parse(this.localStorage.get("currentmeeting"));
    this.myForm.controls["ltxt"].setValue(this.instructionlist.ltxt);
    this.Meetinginstruction.customOpen("lg");
  }
  async Meetinginstructionmodalclose() {
    this.Meetinginstruction.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/shell/forms/shared-modals/online-session/online-session.component.ts